


























































import { Vue, Component } from 'vue-property-decorator';
import { RouteName } from '../routes.constants';
import { LOYALTY_CATEGORY } from './loyalty.constants';

@Component
export default class LoyaltyPage extends Vue {
    RouteName = RouteName
    LOYALTY_CATEGORY = LOYALTY_CATEGORY;
}
